export const tooltipComponent = (text: string) => {
  return (
    <h1
      style={{
        color: "white",
        fontSize: "20px",
      }}
    >
      {text}
    </h1>
  );
};
